import {
  BaseballBoard,
  BasketballBoard,
  BasketballHalfBoard,
  Board,
  BoardType,
  CricketBoard,
  IceHockeyBoard,
  IceHockeyHalfBoard,
  RugbyBoard,
  RugbyHalfBoard,
  SoccerBoard,
  SoccerHalfBoard,
  VolleyballBoard,
  VolleyballHalfBoard,
} from "@sportactics/board-editing";

export function createBoard(boardType: BoardType): Board {
  switch (boardType) {
    case BoardType.Volleyball:
      return new VolleyballBoard();
    case BoardType.VolleyballHalf:
      return new VolleyballHalfBoard();
    case BoardType.Basketball:
      return new BasketballBoard();
    case BoardType.BasketballHalf:
      return new BasketballHalfBoard();
    case BoardType.Soccer:
      return new SoccerBoard();
    case BoardType.SoccerHalf:
      return new SoccerHalfBoard();
    case BoardType.IceHockey:
      return new IceHockeyBoard();
    case BoardType.IceHockeyHalf:
      return new IceHockeyHalfBoard();
    case BoardType.Rugby:
      return new RugbyBoard();
    case BoardType.RugbyHalf:
      return new RugbyHalfBoard();
    case BoardType.Baseball:
      return new BaseballBoard();
    case BoardType.Cricket:
      return new CricketBoard();
  }
}
